





import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@/helpers/decorators'

@Component
export default class Fleet extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.fleet'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
